export default __webpack_public_path__ + "static/media/home1.8e01666a.jpg";